import * as React from 'react'
import { EndlessHolidayProduct } from '@modules/product-package/models'
import { ProductVariantGastroCards } from '@modules/product-package/details/products-selection/product-variant/options/product-variant-gastro-cards'
import { ProductVariantStayOptions } from '@modules/product-package/details/products-selection/product-variant/options/product-variant-stay-options'

interface Props {
  gastroProducts: EndlessHolidayProduct[]
  subscriptionProduct: EndlessHolidayProduct
  children: React.ReactNode
  priceSurplusWithoutGastro: string
}

export const ProductVariantOptions = ({
  gastroProducts,
  subscriptionProduct,
  priceSurplusWithoutGastro,
  children,
}: Props): React.ReactNode => (
  <div className="text-darker-gray endless-holiday__voucher-selection ms-auto col-lg-11 col-12">
    {children}
    <ProductVariantGastroCards
      gastroProducts={gastroProducts}
      subscriptionProduct={subscriptionProduct}
      priceSurplusWithoutGastro={priceSurplusWithoutGastro}
    />
    <ProductVariantStayOptions subscriptionProduct={subscriptionProduct} />
  </div>
)
